var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.markerList),function(item,index){return _c('div',{key:'sceneViewMarker'+item.viewId},[_c('scene-view-marker',{attrs:{"markerInfo":item,"markerIndex":index},on:{"clickMarker":_vm.clickMarker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }